"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockModules = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const store_1 = require("@completeanatomy/store");
const sync_service_1 = require("@completeanatomy/sync-service");
const typedi_1 = require("typedi");
/**
 * Replaces modules in DI container with passed values.
 * !Use only for testing purposes!
 *
 * @param mocks - Map object with modules constructables as keys and mocks as values
 */
function mockModules(mocks) {
    if (!['testing', 'test'].includes(process.env.NODE_ENV || '')) {
        throw new Error('Usage of mockModules function is forbidden outside of testing environment');
    }
    /**
     * Save store and bridge instances
     */
    const store = typedi_1.Container.get(store_1.StoreToken);
    // @ts-ignore
    const bridge = typedi_1.Container.get(bridge_schema_1.BridgeInterface);
    typedi_1.Container.reset();
    typedi_1.Container.set(store_1.StoreToken, store);
    typedi_1.Container.set(bridge_schema_1.BridgeInterface, bridge);
    typedi_1.Container.set({ id: sync_service_1.SyncService, type: sync_service_1.SyncService, eager: true });
    Array.from(mocks.entries()).forEach(([module, mock]) => {
        typedi_1.Container.set({ id: module, type: mock });
    });
}
exports.mockModules = mockModules;
